import service from '../service/address'
import CONSTANT from '../constant/address'
import _ from 'underscore'
import { Indicator } from 'mint-ui';
export default {
    getAddressList ({commit}, data) {
        return new Promise((resolve, reject) => {
            return service.getAddressList(data).then(list => {
                if (_.isEmpty(list)) {
                    resolve([])
                    commit(CONSTANT.ADDRESS_GET_LIST_ERROR_EMPTY)
                    return []
                }
                resolve(list)
                commit(CONSTANT.ADDRESS_GET_LIST_SUCCESS, list)
                return list
            }, e => {
                reject(e)
                commit(CONSTANT.ADDRESS_GET_LIST_ERROR, e)
                // commit('rootApperError', e)
            })
        })
    },
    getDefaultAddress ({commit}, data) {
         Indicator.open();
        return new Promise((resolve, reject) => {
            return service.getDefaultAddress(data).then(result => {
                resolve(result)
                commit(CONSTANT.ADDRESS_GETDEFAULTADDRESS_SUCCESS, result)
                Indicator.close();
                return result
            }, e => {
                reject(e)
                commit(CONSTANT.ADDRESS_GETDEFAULTADDRESS_ERROR, e)
                commit('rootApperError', e)
                Indicator.close();
            })
        })
    },
    addAddress ({commit}, data) {
         Indicator.open();
        return new Promise((resolve, reject) => {
            return service.addAddress(data).then(result => {
                resolve(result)
                commit(CONSTANT.ADDRESS_ADDADDRESS_SUCCESS, result)
                Indicator.close();
                return result
            }, e => {
                reject(e)
                commit(CONSTANT.ADDRESS_ADDADDRESS_ERROR, e)
                commit('rootApperError', e)
                Indicator.close();

            })
        })
    },
    updateAddress ({commit}, data) {
         Indicator.open();
        return new Promise((resolve, reject) => {
            return service.updateAddress(data).then(result => {
                resolve(result)
                commit(CONSTANT.ADDRESS_UPDATEADDRESS_SUCCESS, result)
                Indicator.close();

                return result
            }, e => {
                reject(e)
                commit(CONSTANT.ADDRESS_UPDATEADDRESS_ERROR, e)
                commit('rootApperError', e)
                Indicator.close();

            })
        })
    },
    deleteAddress ({commit}, data) {
         Indicator.open();
        return new Promise((resolve, reject) => {
            return service.deleteAddress(data).then(result => {
                resolve(result)
                commit(CONSTANT.ADDRESS_DELETEADDRESS_SUCCESS, result)
                Indicator.close();

                return result
            }, e => {
                reject(e)
                commit(CONSTANT.ADDRESS_DELETEADDRESS_ERROR, e)
                commit('rootApperError', e)
                Indicator.close();

            })
        })
    },
    changeDefaultAddress ({commit}, data) {
         Indicator.open();
        return new Promise((resolve, reject) => {
            return service.changeDefaultAddress(data).then(result => {
                resolve(result)
                commit(CONSTANT.ADDRESS_CHANGEDEFAULTADDRESS_SUCCESS, result)
                Indicator.close();

                return result
            }, e => {
                reject(e)
                commit(CONSTANT.ADDRESS_CHANGEDEFAULTADDRESS_ERROR, e)
                commit('rootApperError', e)
                Indicator.close();

            })
        })
    },
    getExpressResolveAddress ({commit}, data) {
        Indicator.open();
        return new Promise((resolve, reject) => {
            return service.getExpressResolveAddress(data).then(result => {
                resolve(result)
                commit(CONSTANT.ADDRESS_GETEXPRESSRESOLVEADDRESS_SUCCESS, result)
                Indicator.close();

                return result
            }, e => {
                reject(e)
                commit(CONSTANT.ADDRESS_GETEXPRESSRESOLVEADDRESS_ERROR, e)
                commit('rootApperError', e)
                Indicator.close();

            })
        })
    }
    /*yeoman-template-point-1*/
}
